import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';
import { AccDocModificationModel, IssueCorporateClientBillingPayload, IssuedCorporateClientBillingResult } from './corporate-client-billing.model';

const baseUrl = environment.apiBaseURL + '/corporate-client-billing';
const modificationModelsUrl = baseUrl + '/modification-models';
const issueUrl = baseUrl + '/issue';
const generateProtocolPdfUrl = baseUrl + '/generate-protocol-pdf';

@Injectable({
    providedIn: 'root'
})
export class CorporateClientBillingService {

    constructor(private http: HttpClient) { }

    public getModificationModels(): Observable<AccDocModificationModel[]> {
        return this.http.get<AccDocModificationModel[]>(modificationModelsUrl);
    }

    public issue(payload: IssueCorporateClientBillingPayload): Observable<IssuedCorporateClientBillingResult> {
        return this.http.post<IssuedCorporateClientBillingResult>(issueUrl, payload);
    }

    public generateProtocolPdf(accDocId: number): Observable<Blob> {
        return this.http.get(generateProtocolPdfUrl, { params: { accDocId: accDocId.toString() }, responseType: 'blob' });
    }
}
